/**
 * @generated SignedSource<<b0910b29525718ce973fdac110294940>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnlinkSalesforceOpportunityInput = {
  projectId?: string | null;
  opportunityId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UnlinkSalesforceOpportunityMutation$variables = {
  input: UnlinkSalesforceOpportunityInput;
};
export type UnlinkSalesforceOpportunityMutation$data = {
  readonly unlinkSalesforceOpportunity: {
    readonly project: {
      readonly salesforceOpportunity: string | null;
    } | null;
  } | null;
};
export type UnlinkSalesforceOpportunityMutation = {
  variables: UnlinkSalesforceOpportunityMutation$variables;
  response: UnlinkSalesforceOpportunityMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesforceOpportunity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "unlinkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "unlinkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "59831e02799b8a6e68603cbb842746d6",
    "id": null,
    "metadata": {},
    "name": "UnlinkSalesforceOpportunityMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkSalesforceOpportunityMutation(\n  $input: UnlinkSalesforceOpportunityInput!\n) {\n  unlinkSalesforceOpportunity(input: $input) {\n    project {\n      salesforceOpportunity\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3239137bda25997b25cf6f831fb2d5de";

export default node;
